import { type RoleTypeDto } from '@/api/generated/models/role-type-dto';
import { type UserPermissionDto } from '@/api/generated/models/user-permission-dto';
export const isAuthorized = (
  authorizedRoles: RoleTypeDto[],
  currentUserRole: RoleTypeDto | undefined,
): boolean => {
  if (authorizedRoles.length === 0) {
    return true;
  }
  if (!currentUserRole) {
    return false;
  }
  return authorizedRoles.includes(currentUserRole);
};

export const hasAccessByPermissionCheck = (
  permissionsWithAccess: UserPermissionDto[] | undefined,
  permissions: UserPermissionDto[],
): boolean => {
  if (!permissionsWithAccess) {
    return true;
  }
  return permissions.some(permission => permissionsWithAccess.includes(permission));
};
